import {
  MdArrowForward,
  MdOutlineCopyAll,
  MdOutlineDelete,
  MdOutlineEdit,
} from 'react-icons/md';
import styled from 'styled-components';

const PopupContainer = styled.div`
  display: inline-block;
`;

const IconButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 1.2rem;
`;

const PopupMenu = styled.div`
  position: fixed;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
  border-width: 0px 0px 0px 0px;
  border-style: solid;
  border-color: #eaedf3;
  border-radius: 4px;

  ${({ $position }) =>
    $position.verticalPlacement === 'top'
      ? `bottom: ${window.innerHeight - $position.y}px;`
      : `top: ${$position.y}px;`}

  ${({ $position }) =>
    $position.alignment === 'right'
      ? `right: ${$position.x}px;`
      : `left: ${$position.x}px;`}
`;

const MenuItem = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 40px;

  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.COLOR_GREY5};
      color: #000;
      font-size: 14px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: 0.2px;
      text-align: left;
    }
  }
`;

const DeleteIcon = styled(MdOutlineDelete)`
  margin-right: 10px;
`;

const EditIcon = styled(MdOutlineEdit)`
  margin-right: 10px;
`;

const ViewIcon = styled(MdArrowForward)`
  margin-right: 10px;
`;

const DuplicateIcon = styled(MdOutlineCopyAll)`
  margin-right: 10px;
`;

const Red = styled.span`
  color: ${({ theme }) => theme.COLOR_PRIMARY};
  align-items: center;
`;

const Text = styled.span`
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.2px;
  text-align: left;
  color: ${({ theme, $textColor }) => $textColor || theme.COLOR_BLACK};
`;

const ViewEditDeleteStyle = {
  PopupContainer,
  IconButton,
  PopupMenu,
  DuplicateIcon,
  MenuItem,
  ViewIcon,
  EditIcon,
  DeleteIcon,
  Red,
  Text,
};

export default ViewEditDeleteStyle;
